import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core'
import { FormControl } from '@angular/forms'
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA
} from '@angular/material'

import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { AppService } from '../../../../../services/app.service'
import { StateService } from '../../../../../services/state.service'
import { DialogService} from '../../../../../services/dialog-service.service'




@Component({
	selector: 'atyl-intrction-historique-dialog',
	templateUrl: './instruction-historique-dialog.component.html',
	styleUrls: ['./instruction-historique-dialog.component.scss'],
})

export class InstructionHistoriqueDialog extends BaseDialogComponent implements OnInit {
	loading: boolean = false;
	
   
    instruction: any;
    dossier: any;
    
    historique:any[]=[];
    loadingHistorique:boolean=true;
  
	
	
	now:any=new Date();
	
	title: any
	
    errors:any =[]
    errorMessage:string ="";
    
	constructor(
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<InstructionHistoriqueDialog>,
		public dialog: MatDialog,
		private stateService: StateService,
	   private instructionService:	AppService,
		private appService: AppService,
		dialogService: DialogService

	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
        this.title="Historique";
        console.log("Historique ngOnInit",this.data);
        this.loadingHistorique=true;
		if (this.data) {
			
			
			  
		   if (this.data.dossier!=undefined && this.data.dossier)
	              this.dossier=this.data.dossier;
	              
	       if (this.data.instruction!=undefined && this.data.instruction) { 
			   this.instruction = this.data.instruction;
			   console.log("ngOnInit",this.instruction)
			   if (this.instruction.type)
			    	this.title+=": "+this.instruction.type.libelle;
			   if (this.instruction.demande)
			    	this.title+=" ("+this.instruction.demande.type.libelle+")";
			   
			 	this.instructionService.instruction_historique( this.instruction.ID).subscribe((res: any) => {
	                    this.historique = res.result;
	                 
	                    this.loadingHistorique=false;
	                    this.changeDetectorRef.detectChanges();
	                }
	                
	                
	            );
			}
		}
		
	}
	
	 
	 
	
}
